module.exports = __webpack_public_path__ + "static/media/eyeShut.41c7831c.svg";